var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPort(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PoE_Icon",
    "data-name": "PoE Icon",
    transform: "translate(-2266 -22986)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union_163",
    "data-name": "Union 163",
    transform: "translate(2266 22986)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.189,17H0V0H20V17H15.811C15.145,18.725,12.8,20,10,20S4.855,18.725,4.189,17Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9.999899864196777 17.99979972839355 C 11.02114009857178 17.99979972839355 12.00708961486816 17.77795028686523 12.77612972259521 17.37512969970703 C 13.3705997467041 17.06373977661133 13.79677963256836 16.6644401550293 13.94540023803711 16.27960014343262 L 14.43951988220215 15.00010013580322 L 17.99979972839355 15.00010013580322 L 17.99979972839355 1.99999988079071 L 1.99999988079071 1.99999988079071 L 1.99999988079071 15.00010013580322 L 5.560269832611084 15.00010013580322 L 6.054389953613281 16.27960014343262 C 6.203010082244873 16.6644401550293 6.629189968109131 17.06373977661133 7.223659992218018 17.37512969970703 C 7.992700099945068 17.77795028686523 8.978659629821777 17.99979972839355 9.999899864196777 17.99979972839355 M 9.999899864196777 19.99979972839355 C 7.204079627990723 19.99979972839355 4.854809761047363 18.72501945495605 4.188679695129395 17.00009918212891 L -1.358032193365943e-07 17.00009918212891 L -1.358032193365943e-07 -1.358032193365943e-07 L 19.99979972839355 -1.358032193365943e-07 L 19.99979972839355 17.00009918212891 L 15.81110954284668 17.00009918212891 C 15.14497947692871 18.72501945495605 12.79572010040283 19.99979972839355 9.999899864196777 19.99979972839355 Z",
    stroke: "none",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2138",
    "data-name": "Rectangle 2138",
    width: 3,
    height: 4,
    transform: "translate(2281 22988)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2139",
    "data-name": "Rectangle 2139",
    width: 4,
    height: 4,
    transform: "translate(2274 22988)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2140",
    "data-name": "Rectangle 2140",
    width: 3,
    height: 4,
    transform: "translate(2268 22988)",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPort);
export default __webpack_public_path__ + "static/media/port.d210dbaa111e8d45318917402ef4cab5.svg";
export { ForwardRef as ReactComponent };